import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { birthdayRewardFormDefault } from "@factory/form/form.default";
import { BirthdayRewardFormRule, BirthdayRewardFormSchema } from "@factory/form/form.rule";
import { useQyCreateBirthdayReward } from "@factory/query/birthday-reward.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewBirthdayReward() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateBirthdayReward } = useFormApiMapper();
  const { showError, showSuccess } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New BirthdayReward is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addBirthdayReward, isLoading: isCreating } =
    useQyCreateBirthdayReward(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<BirthdayRewardFormSchema>({
    defaultValues: birthdayRewardFormDefault,
    resolver: zodResolver(BirthdayRewardFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: BirthdayRewardFormSchema) => {
    const formData = mapCreateBirthdayReward(form);
    addBirthdayReward(formData);
  };
  const handleValidateError = (err: FieldErrors<BirthdayRewardFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
